import { render, staticRenderFns } from "./assetList.vue?vue&type=template&id=c6b243f0&"
import script from "./assetList.vue?vue&type=script&lang=js&"
export * from "./assetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports